import React, { useState, useEffect } from "react";

// react-router components
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
// import Icon from "@mui/material/Icon";

// Soft UI Dashboard React components
// import SoftBox from "components/SoftBox";

// Soft UI Dashboard React examples
import Sidenav from "examples/Sidenav";
import Configurator from "examples/Configurator";

// Soft UI Dashboard React themes
import theme from "assets/theme";

// Soft UI Dashboard React routes
import routes from "routes";

// Soft UI Dashboard React contexts
// import { useSoftUIController, setMiniSidenav, setOpenConfigurator } from "context";
import { useSoftUIController, setMiniSidenav } from "context";

// Images
import brand from "assets/images/logo-ct.png";
import OrderDetailsV2 from "layouts/dashboard/components/ForProjects/OrderDetailsV2";
import EditDetail from "layouts/dashboard/components/ForProjects/OrderDetails/EditDetail";
import CreateEmailTemplate from "layouts/emailSettings/CreateEmailTemplate";
import EmailSettings from "layouts/emailSettings";
import CreateStatusSettings from "layouts/statusSettings/CreateStatusSettings";
import StatusSettings from "layouts/statusSettings";
import StatusMappings from "layouts/statusMappings";
import CreateStatusMapping from "layouts/statusMappings/CreateStatusMapping";
import AutomationRules from "layouts/automationRules";
import CreateAutomationRule from "layouts/automationRules/CreateAutomationRule";
import ProtectedRoute from "proctectedRoute/ProtectedRoute";
import SearchAddress from "components/SearchAddress";
import CalculateArea from "components/SearchAddress/CalculateArea";
import Summary from "components/SearchAddress/Summary";
import MaintenancePage from "components/MaintenancePage/MaintenancePage";
import LogIn from "layouts/authentication/sign-in";
import ForgotPassword from "layouts/authentication/forgot-password";
import ResetPassword from "layouts/authentication/reset-password";
import App_logo from "assets/images/BMAx_orderSystem.png";
import DashboardSearchAddress from "components/DashboardSearchAddress";
import VendorLink from "components/VendorLink";
import ApiDocs from "layouts/apiDocs";
import DashboardCalculateArea from "components/DashboardSearchAddress/CalculateArea";
import DashboardSummary from "components/DashboardSearchAddress/Summary";
import ToastProvider from 'components/ToastProvider';
import APIIntents from "layouts/apiIntents";
import EditIntent from "layouts/apiIntents/edit";
import NotFound from "./pages/NotFound";

import "./app.css";

export default function App() {
  const [controller, dispatch] = useSoftUIController();
  const { miniSidenav, layout, openConfigurator, sidenavColor } = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const { pathname } = useLocation();
  const loggedIn = localStorage.getItem('loggedIn');
  console.log('loggedIn', loggedIn);

  // Open sidenav when mouse enter on mini sidenav
  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  // Close sidenav when mouse leave mini sidenav
  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  // Change the openConfigurator state
  // const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !openConfigurator);

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return <Route exact path={route.route} element={route.component} key={route.key} />;
      }

      return null;
    });

  // const configsButton = (
  //   <SoftBox
  //     display="flex"
  //     justifyContent="center"
  //     alignItems="center"
  //     width="3.5rem"
  //     height="3.5rem"
  //     bgColor="white"
  //     shadow="sm"
  //     borderRadius="50%"
  //     position="fixed"
  //     right="2rem"
  //     bottom="2rem"
  //     zIndex={99}
  //     color="dark"
  //     sx={{ cursor: "pointer" }}
  //     onClick={handleConfiguratorOpen}
  //   >
  //     <Icon fontSize="default" color="inherit">
  //       settings
  //     </Icon>
  //   </SoftBox>
  // );

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ToastProvider />
      {loggedIn && layout === "dashboard" && pathname !== "/search-address" && pathname !== "/home" && !pathname.startsWith("/authentication/") && !pathname.startsWith("/tilbakestill-passord/") && !pathname.startsWith("/leveranse/") && (
        <>
          <Sidenav
            color={sidenavColor}
            brand={App_logo}
            brandName=""
            routes={routes}
            onMouseEnter={handleOnMouseEnter}
            onMouseLeave={handleOnMouseLeave}
          />
          {/* <Configurator /> */}
          {/* {configsButton} */}
        </>
      )}


      <Routes>
        {getRoutes(routes)}
        {loggedIn && (
          <Route path="/" element={<Navigate to="/add-address" />} />
        )}
        <Route path="/" element={<Navigate to="/authentication/log-in" />} />
        <Route path="/authentication/log-in" element={<LogIn />} />
        <Route path="/authentication/forgot-password" element={<ForgotPassword />} />
        {/* Public reset link from the password reset e-mail — the token is the credential */}
        <Route path="/tilbakestill-passord/:token" element={<ResetPassword />} />
        {/*  <Route path="/" element={<Navigate to="/home" />} /> */}
        {/* <Route path="/" element={<Navigate to="/search-address" />} /> */}
        {/* V2-siden er den eneste ordrevisningen, og eier nå den klassiske
            URL-en. Redigeringssiden /bestillinger/edit-details består. */}
        <Route
          path="/bestillinger/order-details/:orderId"
          element={
            <ProtectedRoute
              allowedRoles={["admin", "customer", "vendor"]}
              element={<OrderDetailsV2 />}
            />
          }
        />
        <Route
          path="/bestillinger/edit-details/:orderId"
          element={
            <ProtectedRoute
              allowedRoles={["admin", "vendor"]}
              element={<EditDetail />}
            />
          }
        />

        <Route
          path="/email-settings"
          element={
            <ProtectedRoute
              allowedRoles={["admin"]}
              element={<EmailSettings />}
            />
          }
        />

        <Route
          path="/email-settings/create-template"
          element={
            <ProtectedRoute
              allowedRoles={["admin"]}
              element={<CreateEmailTemplate />}
            />
          }
        />

        <Route
          path="/email-settings/edit-template/:templateId"
          element={
            <ProtectedRoute
              allowedRoles={["admin"]}
              element={<CreateEmailTemplate />}
            />
          }
        />

        <Route
          path="/status-settings"
          element={
            <ProtectedRoute
              allowedRoles={["admin"]}
              element={<EmailSettings />}
            />
          }
        />

        <Route
          path="/status-settings/create-statusSettings"
          element={
            <ProtectedRoute
              allowedRoles={["admin"]}
              element={<CreateStatusSettings />}
            />
          }
        />

        <Route
          path="/status-settings/edit-statusSettings/:statusId"
          element={
            <ProtectedRoute
              allowedRoles={["admin"]}
              element={<CreateStatusSettings />}
            />
          }
        />

        <Route
          path="/status-mappings"
          element={
            <ProtectedRoute
              allowedRoles={["admin"]}
              element={<StatusMappings />}
            />
          }
        />
        <Route
          path="/status-mappings/create"
          element={
            <ProtectedRoute
              allowedRoles={["admin"]}
              element={<CreateStatusMapping />}
            />
          }
        />
        <Route
          path="/status-mappings/edit/:mappingId"
          element={
            <ProtectedRoute
              allowedRoles={["admin"]}
              element={<CreateStatusMapping />}
            />
          }
        />

        <Route
          path="/automation-rules"
          element={
            <ProtectedRoute
              allowedRoles={["admin"]}
              element={<AutomationRules />}
            />
          }
        />
        <Route
          path="/automation-rules/new"
          element={
            <ProtectedRoute
              allowedRoles={["admin"]}
              element={<CreateAutomationRule />}
            />
          }
        />
        <Route
          path="/automation-rules/edit/:id"
          element={
            <ProtectedRoute
              allowedRoles={["admin"]}
              element={<CreateAutomationRule />}
            />
          }
        />


        {/* Public producer acceptance link — no auth, the hash is the credential */}
        <Route path="/leveranse/:token" element={<VendorLink />} />

        {/* Public API docs — describes the open vendor API, holds no secrets,
            and the vendor's developers rarely have a BMAX login. */}
        <Route path="/api-dokumentasjon" element={<ApiDocs />} />

        {/* Public order creation routes */}
        <Route path="/home" element={<MaintenancePage />} />
        <Route path="/search-address" element={<SearchAddress />} />
        <Route path="/calculate-area" element={<CalculateArea />} />
        <Route path="/summary" element={<Summary />} />

        {/* Dashboard order creation routes */}
        <Route path="/add-address" element={<DashboardSearchAddress />} />
        <Route path="/area-calculate" element={<DashboardCalculateArea />} />
        <Route path="/summary-info" element={<DashboardSummary />} />

        {/* AI Intents routes */}
        <Route
          path="/ai-intents"
          element={
            <ProtectedRoute
              allowedRoles={["admin"]}
              element={<APIIntents />}
            />
          }
        />
        <Route
          path="/ai-intents/edit/:intentId"
          element={
            <ProtectedRoute
              allowedRoles={["admin"]}
              element={<EditIntent />}
            />
          }
        />

	<Route path="*" element={<NotFound />} />

      </Routes>
    </ThemeProvider>
  );
}
